import { pick } from 'lodash-es'
import { withQuery } from 'ufo'
import { normalizePath, withLanguagePrefix } from '~/utils/urls'
import { isTripFlexible, getTripDateQuery } from '~/utils/trip'

export function getAccommodationDestination({
  country,
  region,
  place,
}: TranslatedAccommodation): Destination {
  return {
    countryCode: country.code,
    country: country.name,
    regionCode: region.code,
    region: region.name,
    placeCode: place.code,
    place: place.name,
  } as Destination
}

export function getResultDocumentDestination({
  country,
  region,
  place,
}: ResultDocument): Destination {
  return { country, region, place } as Destination
}

export function getAccomKey(
  accom: Pick<SearchResultDocument, 'code' | 'trip'>,
): string {
  return JSON.stringify(pick(accom, 'code', 'trip'))
}

export function getAccomUrl(
  { languagePrefix, partnerId, persistentParams }: AppContext,
  accom: { code: string; slug?: string; trip?: Trip },
  trip?: Partial<UnparsedTripParams>,
): string {
  const path = withLanguagePrefix(accom.slug || accom.code, languagePrefix)
  const params = {
    // For flexible search date period is taken from trip object
    ...getTripDateQuery((isTripFlexible(trip ?? {}) ? accom.trip : trip) ?? {}),
    pax: trip?.pax,
    partnerid: partnerId,
    ...persistentParams,
  }

  return withQuery(normalizePath(path), removeEmpty(params))
}

export function getAccomPaxMax(
  accom: { pax: Pax },
  trip?: Partial<TripParams>,
) {
  const { validities, capacity } = accom.pax
  const checkin = trip?.checkin && toDate(trip.checkin)

  const [validity] =
    validities.length > 1 && checkin
      ? validities.filter(
          ({ from, to }) =>
            (!from && checkin <= to) ||
            (from <= checkin && checkin <= to) ||
            (from <= checkin && !to),
        )
      : validities

  return validity?.value ?? capacity
}
